import * as React from 'react';
import Select, { components } from "react-select";
import { IAIcon } from '../icon/Icon';
import * as styles from './IconDropDown.css';
import { IIconDropDown } from '../../interfaces/IIconDropDown';
import { Helper } from '../../Helper';

export interface IIconDropDownProps {
  options: IIconDropDown[];
  selectedOption: IIconDropDown;
  style: React.CSSProperties;
  loading?: boolean;
  disabled?: boolean;
  clearable?: boolean;
  label?: string;
  placeholder?: string;
  darkMode?: boolean;
  highlightColor?: string;
  onChange: (selected: IIconDropDown) => void;
}

export interface IIconDropDownState {
}

export class IAIconDropDown extends React.Component<IIconDropDownProps, IIconDropDownState> {

  constructor(props: IIconDropDownProps) {
    super(props);
    this.state = {
    }
  }

  public render(): JSX.Element {
    const { Option } = components;
    const IconOption = props => (
      <Option {...props}>
        <div className={styles.IA_option}>
          <div className={styles.IA_icon}>
            <IAIcon
              title={props.data.icon}
              url={props.data.iconUrl}
              color={props.data?.iconColor ? props.data?.iconColor : (this.props.darkMode ? "#ffffff" : "#333333")}
              size={20}
              style={{ marginTop: 6, zIndex: 100 }}
            />
          </div>
          <div className={styles.IA_label} style={{ color: this.props.darkMode ? Helper.darkModeLabelColor : '#333333' }}>
            {props.data.label}
          </div>
        </div>
      </Option>
    );
    return (
      <div style={{
        ...this.props.style
      }}
      >
        {this.props.label &&
          <label style={{ fontSize: 12, lineHeight: "30px", color: this.props.darkMode ? Helper.darkModeLabelColor : '#000' }}>{this.props.label?.toUpperCase()}</label>
        }
        <Select
          value={this.props.selectedOption}
          options={this.props.options}
          isLoading={this.props.loading}
          isDisabled={this.props.disabled}
          isClearable={this.props.clearable}
          isSearchable={false}
          tabIndex={0}
          placeholder={this.props.placeholder}
          components={{ Option: IconOption }}
          onChange={(selected: IIconDropDown) => {
            this.props.onChange(selected);
          }}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary: this.props.highlightColor ?? theme.colors.primary
            }
          })}
          styles={{
            menuList: (provided) => (this.props.darkMode ? {
              ...provided,
              backgroundColor: Helper.darkModeInputFieldBackgroundColor,
              borderStyle: "none"
            } : {
              ...provided,
            }),
            option: (provided, state) => (this.props.darkMode ? {
              ...provided,
              backgroundColor: state.isSelected ? Helper.darkModeCardBackgroundColor : (state.isFocused || state.isSelected ? "#555454" : Helper.darkModeInputFieldBackgroundColor),
              color: '#fff',
            } : {
              ...provided,
              backgroundColor: state.isSelected ? "#dddddd" : (state.isFocused || state.isSelected ? "#eeeeee" : "#ffffff"),
            }),
            control: (provided) => (this.props.darkMode ? {
              ...provided,
              backgroundColor: Helper.darkModeInputFieldBackgroundColor,
              color: '#fff',
              borderStyle: "none",
              cursor: "pointer"
            } : {
              ...provided,
              cursor: "pointer"
            }),
            valueContainer: (provided) => {
              return {
                ...provided,
                paddingLeft: this.props.selectedOption ? 40 : 10,
                display: "flex",
                alignItems: "center"
              };
            },
            singleValue: (provided) => {
              return {
                ...provided,
                color: this.props.darkMode ? '#fff' : '#333333'
              }
            }
          }}
        />
        {this.props.selectedOption &&
          <IAIcon
            title={this.props.selectedOption?.icon}
            url={this.props.selectedOption?.iconUrl}
            size={20}
            color={this.props.selectedOption?.iconColor ? this.props.selectedOption?.iconColor : (this.props.darkMode ? "#ffffff" : "#333333")}
            style={{
              marginTop: -28,
              position: "relative",
              zIndex: 999999,
              marginLeft: 12,
              pointerEvents: "none"
            }}
          />
        }
      </div>
    );
  }


}